import DocumentProfilePencil from "@9amhealth/shared/icons/DocumentProfilePencil";
import IconCardPhoto from "@9amhealth/shared/icons/IconCardPhoto";
import IconEducation from "@9amhealth/shared/icons/IconEducation";
import IconGraduationHat from "@9amhealth/shared/icons/IconGraduationHat";
import type { ReactNode } from "react";
import React from "react";
import {
  IconClipboardApple,
  IconCssPerson,
  IconHeartWithHeartBeatLine,
  IconIllustrationArmMuscle,
  IconMdPerson,
  IconPharmDPerson,
  IconPillBottle,
  IconRDPerson,
  IconSyringe,
  IconTaskClipboardVial,
  IconTaskLabAtHome,
  IconTaskMoneyShield,
  IconTaskPapersheetPencil,
  IconTaskPersonWithStethoscope,
  IconTaskPharmacyMedicalCupSnakeBowlOfHygieia,
  IconTaskStethoscope,
  IconWeightScale
} from "src/constants/icons";

const TaskIcons: Record<string, ReactNode> = {
  "card-photo": <IconCardPhoto />,
  education: <IconEducation />,
  "clipboard-vial": <IconTaskClipboardVial />,
  stethoscope: <IconTaskStethoscope />,
  "doctor-card": <IconTaskPersonWithStethoscope />,
  "money-shield": <IconTaskMoneyShield />,
  form: <IconTaskPapersheetPencil />,
  "bowl-of-hygiena": <IconTaskPharmacyMedicalCupSnakeBowlOfHygieia />,
  "home-labs": <IconTaskLabAtHome />,
  arm: <IconIllustrationArmMuscle />,
  "clipboard-apple": <IconClipboardApple />,
  "heart-beat": <IconHeartWithHeartBeatLine />,
  "weight-scale": <IconWeightScale />,
  pen: <IconSyringe />,
  medication: <IconPillBottle />,
  md: <IconMdPerson />,
  rd: <IconRDPerson />,
  pharmd: <IconPharmDPerson />,
  ccs: <IconCssPerson />,
  "checked-document": <DocumentProfilePencil />,
  "graduation-hat": <IconGraduationHat />
};

export default TaskIcons;
